import React, { Component } from "react";
import { connect } from "react-redux";
import format from "date-fns/format";
import sub from "date-fns/sub";
import isAfter from "date-fns/isAfter";
import parseISO from "date-fns/parseISO";
import { Utils } from "services/utils";
import { DIMENSIONS } from "services/layoutManager";
import { BloxButton } from "styled_components/Common/BloxButton";
import { DataCenterApi } from "services/datacenter";
import { NotificationsApi } from "services/notifications";
import { BadgeAccess } from "styled_components/Account/BadgeAccess";
import { PortalAccess } from "styled_components/Account/PortalAccess";
import { Permissions } from "services/permissions";
import { MENU as PROFILE_MENU } from "utils/ProfileConstants";
import { SITE_PAGES, SITE_MODULES } from "utils/CommonConstants";
import { CompanyProfileApi } from "services/companyProfile";
import {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import BloxPage from "sub_components/Layout/BloxPage";
import ComponentWrapper from "sub_components/Layout/ComponentWrapper";
import { RESOLUTIONS } from "services/config";
import { ListComponent } from "styled_components/Account/ListComponent";
import { Filter } from "styled_components/Common/Filter";
import { Sort } from "styled_components/Common/Sort";
import { SortProvider } from "context/SortContext";
import { FilterProvider } from "context/FilterContext";
import { updatePermissions } from "actions/permissions";
import { getUserPermissions, setUserPermissions } from "services/user";

const Notification_Filters = ["All", "Portal Logins", "Badge Access"];
const Notification_Sort = [
  { displayValue: "All", value: 0 },
  { displayValue: "30 Days - ASC", value: 29 },
  { displayValue: "180 Days - ASC", value: 179 },
  { displayValue: "30 Days - DESC", value: 30 },
  { displayValue: "180 Days - DESC", value: 180 },
];

const LAYOUT_CONFIG = {
  [RESOLUTIONS.LOW]: {
    notifications: { x: 1, y: 4, dim: DIMENSIONS.EIGHT_BY_TEN },
  },
  [RESOLUTIONS.MED]: {
    notifications: { x: 1, y: 4, dim: DIMENSIONS.EIGHT_BY_TEN },
  },
  [RESOLUTIONS.HIGH]: {
    notifications: { x: 1, y: 4, dim: DIMENSIONS.EIGHT_BY_TEN },
  },
};

class NotificationsPage extends Component {
  constructor(props) {
    super(props);
    this.companyApi = new CompanyProfileApi();
    this.state = {
      error: false,
      selectedPage: null,
      selectedSection: null,
      selectedHeaderSelections: null,
      rosterUserDetails: null,
      organizationId: null,
      pages: null,
      notifications: [],
      role: "",
      filterSelected: "All",
      sortSelected: "All",
      badgeData: false,
      sessionData: false,
      documentData: false,
    };
  }

  componentDidMount() {
    const {
      updateModule,
      updatePage,
      addPageToBreadCrumbs,
      site,
      permissions,
    } = this.props;
    updatePage(SITE_PAGES.PROFILE[PROFILE_MENU.NOTIFICATIONS]);
    addPageToBreadCrumbs(
      SITE_PAGES.PROFILE[PROFILE_MENU.NOTIFICATIONS],
      SITE_MODULES.ACCOUNT
    );
    if (site?.module !== "ACCOUNT" || !permissions?.permissions) {
      this.getModulePages();
    }
    updateModule(SITE_MODULES.ACCOUNT);
    this.setHeaderSelection("portal");
    this.getUsersTimezone();
    this.checkForCompanyId();
  }
  checkUsersPermissions = (id) => {
    const { auth_status: { user } = {} } = this.props;
    const { rosterUserDetails } = this.state;

    const currentUsersRole = this.getUsersRole(id);

    if (!rosterUserDetails) {
      this.getRosterUsers(id, user.id);
    }

    this.getPortalLogs(currentUsersRole);
    this.getUserAccessLogs(currentUsersRole, user.id);
    this.getBadgeLogs(currentUsersRole);
  };
  getUserAccessLogs = (role, userId) => {
    const { documentData } = this.state;
    if (!documentData) {
      NotificationsApi.getUserAccessLogs(userId)
        .then((response) => {
          const validResponse =
            response.status === 200 && response.data?.notifications;
          const { notifications } = this.state;
          if (validResponse) {
            let logList = [];
            if (role === "member") {
              const logs = response.data?.notifications;
              const filterLogsUserOnly = logs.filter(
                (log) => log.userid === user?.id
              );
              logList = filterLogsUserOnly;
            } else {
              logList = response.data?.notifications;
            }
            const activitiesData = this.formatNotifications(logList);
            activitiesData.forEach((item) => notifications.push(item));

            this.setState({ notifications, documentData: true });
          } else {
          }
        })
        .catch(() => {});
    }
  };
  getPortalLogs = (role) => {
    const {
      auth_status: { user },
      company_info: { customer: { id } } = {},
    } = this.props;
    const params = {
      organizationId: id,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    const { notifications, sessionData } = this.state;

    if (!sessionData) {
      NotificationsApi.getPortalAccessDetails(params)
        .then((response) => {
          const validResponse = response.status === 200 && response.data;
          if (validResponse) {
            let logsList = [];

            if (role === "member") {
              const logs = response.data?.notifications;
              const filterLogsUserOnly = logs.filter(
                (log) => log.userid === user?.id
              );
              logsList = filterLogsUserOnly;
            } else {
              logsList = response.data?.notifications;
            }

            const activitiesData = this.formatNotifications(logsList);
            activitiesData.forEach((item) => notifications.push(item));
            this.setState({ notifications, sessionData: true });
          } else {
          }
        })
        .catch(() => {});
    }
  };
  getBadgeLogs = () => {
    const {
      auth_status: { user },
      company_info: { customer: { id } } = {},
    } = this.props;

    const { notifications, badgeData } = this.state;
    if (!badgeData) {
      NotificationsApi.getOrgDataCenterAccess(id, user.id)
        .then((response) => {
          const validResponse = response.status === 200 && response.data;
          if (validResponse) {
            const logs = response.data?.notifications;
            const activitiesData = this.formatNotifications(logs);

            activitiesData.forEach((item) => notifications.push(item));
            this.setState({
              notifications,
              badgeData: true,
            });
          } else {
            this.setState({ error: "Error getting badge details" });
          }
        })
        .catch(() => {
          this.setState({ error: "Error getting badge details" });
        });
    }
  };
  checkForCompanyId = () => {
    const {
      company_info: { customer: { id } = {} },
    } = this.props;
    const { organizationId: existingId, error } = this.state;

    if (id !== existingId && !error) {
      this.setState({ organizationId: id }, () => {
        this.getRosterUsers(id);
        this.checkUsersPermissions(id);
      });
    }
  };
  componentDidUpdate() {
    const { organizationId, selectedPage, pages } = this.state;
    const { auth_status } = this.props;
    if (!organizationId) {
      this.checkForCompanyId();
    }

    if (!selectedPage && auth_status && pages) {
      this.setSelection("details");
    }
  }
  getRosterUsers(organizationId) {
    const {
      auth_status: {
        user: { id },
      },
    } = this.props;

    DataCenterApi.getAllRosterUsers(organizationId)
      .then((response) => {
        const validResponse = response.status === 200 && response.data;
        if (validResponse) {
          const rosterUserDetail = this.getRosterUserDetails(
            id,
            response.data?.rosterUsers
          );

          this.setState({ rosterUserDetails: rosterUserDetail }, () => {
            this.checkUsersPermissions(organizationId);
          });
        } else {
          this.setState({ error: "Error pulling users" });
        }
      })
      .catch(() => this.setState({ error: "Error pulling users" }));
  }
  getRosterUserDetails = (id, rosterUsers) => {
    if (!id) {
      return null;
    }

    if (rosterUsers) {
      const filteredUsers = rosterUsers.filter(
        (user) => user.userId === parseInt(id)
      );
      if (filteredUsers && filteredUsers[0]) {
        return filteredUsers[0];
      } else {
        return null;
      }
    }

    return null;
  };
  getUsersRole = (id) => {
    const { auth_status } = this.props;
    const { role } = this.state;
    const { memberships = {} } = auth_status;
    const currentMembershipSelected = memberships.filter(
      (membership) => Number(membership.organizationId) === Number(id)
    );
    if (currentMembershipSelected[0]?.role !== role) {
      this.setState({ role: currentMembershipSelected[0]?.role });
    }
    return currentMembershipSelected[0]?.role;
  };

  getUsersTimezone = () => {
    console.log(Intl.DateTimeFormat().resolvedOptions().timeZone);
  };

  getModulePages = async () => {
    const {
      updatePermissions,
      auth_status: {
        user: { id: userId },
      },
      company_info: {
        customer: { id: orgId },
      },
    } = this.props;

    const permissions = getUserPermissions("account");
    if (!permissions) {
      const response = await Permissions.getModulePermissions(3, userId, orgId);
      if (response && !response.data.error) {
        setUserPermissions("account", response.data.pages);
        updatePermissions(response.data.pages);
      }
    } else {
      updatePermissions(permissions);
    }
  };

  sendSOC = () => {
    const {
      company_info: {
        customer: { id },
      },
      setModalContent,
    } = this.props;

    const button = (
      <BloxButton
        className="buttons41"
        id="okay"
        text="OKAY"
        module="account"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );

    this.companyApi
      .sendSOC(id)
      .then((response) => {
        const validResponse = response.status === 200 && response.data;
        if (validResponse) {
          setModalContent(
            "TIMEOUT_CLOSE",
            "Please check your emails for the requested report.",
            button
          );
        } else {
          setModalContent("TIMEOUT_CLOSE", "Error sending SOC report.", button);
        }
      })
      .catch(
        () => setModalContent("TIMEOUT_CLOSE", "Error sending SOC report."),
        button
      );
  };

  setHeaderSelection = (selection) => {
    let selectedHeaderSelections = null;
    if (selection === "portal") {
      selectedHeaderSelections = [
        {
          label: "Activities",
          value: "activities",
        },
      ];
    } else {
      selectedHeaderSelections = [
        {
          label: "Activities",
          value: "dc-activities",
        },
      ];
    }

    this.setSelection(selectedHeaderSelections[0]?.value);

    this.setState({ selectedHeaderSelections, selectedSection: selection });
  };

  setSelection = (selection) => {
    const {
      company_info,
      auth_status: { user },
      company_info: { customer: { id } = {} } = {},
      permissions: pages,
    } = this.props;

    const { rosterUserDetails } = this.state;
    const hasDownloadDocumentAccess = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "download-documents"
    );

    let selectedPage = "";
    const role = this.getUsersRole(company_info?.customer?.id);
    switch (selection) {
      case "activities":
        selectedPage = (
          <PortalAccess role={role} user={user} organizationId={id} />
        );
        break;
      case "dc-activities":
        selectedPage = (
          <BadgeAccess
            role={role}
            user={user}
            organizationId={id}
            onClick={this.sendSOC}
            rosterUser={rosterUserDetails}
            hasDownloadDocumentAccess={hasDownloadDocumentAccess}
          />
        );
        break;
      case "badges":
        selectedPage = (
          <BadgeAccess
            role={role}
            user={user}
            organizationId={id}
            rosterUser={rosterUserDetails}
            hasDownloadDocumentAccess={hasDownloadDocumentAccess}
          />
        );
        break;
      default:
        selectedPage = <div>Notificaions 2</div>;
    }
    this.setState({ selectedPage, selectedPageValue: selection });
  };

  formatNotifications = (portalSessions) => {
    const {
      auth_status: { user },
    } = this.props;

    if (!portalSessions) {
      return activitiesData;
    }
    const updatedActivitiesData = [];
    try {
      portalSessions.map((session) => {
        const timestamp = parseISO(session?.created_dt);
        const displayDate = format(timestamp, "MM-dd-yy");
        const displayTime = format(timestamp, "h:mm a ");

        updatedActivitiesData.push({
          startDate: timestamp,
          type: session?.accesstype,
          displayDate,
          values: [
            { label: user?.userName, size: "md" },
            { label: session?.accesstype, size: "lg" },
            { label: session?.city, size: "sm" },
            { label: displayDate, size: "sm" },
            { label: displayTime, size: "sm" },
          ],
          expandedHeaders: [{ label: "Description", size: "single" }],
          expandedSize: "sm",
          expandedValues: [
            {
              one: {
                value: session?.eventtype,
                size: "sm",
              },
            },
          ],
        });
      });
    } catch (error) {
      console.log(error);
    }

    return updatedActivitiesData;
  };
  getHeaders = () => {
    return [
      { label: "Username", size: "md" },
      { label: "Description", size: "lg" },
      { label: "City", size: "sm" },
      { label: "Date", size: "sm" },
      { label: "Time", size: "sm" },
    ];
  };
  filterNotifications = (selectedFilter, notificationsList) => {
    let notifications = [];

    if (selectedFilter === "Portal Logins") {
      notifications = notificationsList.filter(
        (notification) => notification.type === "Login"
      );
    } else if (selectedFilter === "Badge Access") {
      notifications = notificationsList.filter(
        (notification) => notification.type === "CardAdmitted"
      );
    } else {
      notifications = notificationsList;
    }

    notifications = notifications && Utils.sort(notifications);
    return notifications;
  };

  getFilterNotifications = (selectedSort, notifications) => {
    const today = sub(new Date(), { days: selectedSort?.value });
    const filterNotifications = [];
    let newNotifications = notifications;

    switch (selectedSort?.displayValue) {
      case "All":
        newNotifications = Utils.sort(notifications);
        break;
      case "30 Days - ASC":
        newNotifications = Utils.sort(notifications).reverse();

        notifications.forEach((notification) => {
          const timestamp = new Date(notification.startDate);
          if (isAfter(timestamp, today)) {
            filterNotifications.push(notification);
          }
        });

        newNotifications = filterNotifications;
        break;
      case "180 Days - ASC":
        newNotifications = Utils.sort(notifications).reverse();

        notifications.forEach((notification) => {
          const timestamp = new Date(notification.startDate);

          if (isAfter(timestamp, today)) {
            filterNotifications.push(notification);
          }
        });

        newNotifications = filterNotifications;
        break;

      case "30 Days - DESC":
        newNotifications = Utils.sort(notifications);

        notifications.forEach((notification) => {
          const timestamp = new Date(notification.startDate);

          if (isAfter(timestamp, today)) {
            filterNotifications.push(notification);
          }
        });

        newNotifications = filterNotifications;
        break;

      case "180 Days - DESC":
        newNotifications = Utils.sort(notifications);

        notifications.forEach((notification) => {
          const timestamp = new Date(notification.startDate);

          if (isAfter(timestamp, today)) {
            filterNotifications.push(notification);
          }
        });
        newNotifications = filterNotifications;
        break;

      default:
    }
    return newNotifications;
  };

  sortData = (notificationsList, filterSelected, selectedSort) => {
    const notifications = this.filterNotifications(
      filterSelected,
      notificationsList
    );
    let newNotifications = notifications;

    const notificationsNotEmpty = notifications && notifications.length !== 0;
    if (notificationsNotEmpty) {
      newNotifications = this.getFilterNotifications(
        selectedSort,
        notifications
      );
    }

    return newNotifications;
  };
  updateFilterSelected = (selected) => {
    this.setState({ filterSelected: selected });
  };

  updateSortSelected = (selected) => {
    this.setState({ sortSelected: selected });
  };
  render() {
    const { filterSelected, sortSelected, notifications } = this.state;
    const {
      breakpoint,
      location,
      setModalContent,
      company_info: {
        customer: { id },
      },
    } = this.props;

    return (
      <BloxPage
        name="page account-management-page"
        layout={LAYOUT_CONFIG[breakpoint]}
        breakpoint={breakpoint}
        location={location}
        setModalContent={setModalContent}
      >
        <div key={`notifications`} className="notifications">
          <ComponentWrapper title="Activities" hideBorder>
            <FilterProvider>
              <SortProvider>
                <ListComponent
                  headers={this.getHeaders()}
                  organizationId={id}
                  breakpoint={breakpoint}
                  module="account"
                  className="lg"
                  data={this.sortData(
                    notifications,
                    filterSelected,
                    sortSelected
                  )}
                >
                  <Filter
                    selected={filterSelected}
                    options={Notification_Filters}
                    callback={this.updateFilterSelected}
                    module="account"
                  />
                  <Sort
                    selected={{ displayValue: "All", value: 0 }}
                    options={Notification_Sort}
                    callback={this.updateSortSelected}
                    module="account"
                  />
                </ListComponent>
              </SortProvider>
            </FilterProvider>
          </ComponentWrapper>
        </div>
      </BloxPage>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
    theme: state.theme,
    site: state.site_tracking,
    permissions: state.permissions,
  };
}

export default connect(mapStateToProps, {
  updatePage,
  updateModule,
  addPageToBreadCrumbs,
  updatePermissions,
})(NotificationsPage);
